import { render, staticRenderFns } from "./TaskBar.vue?vue&type=template&id=9ffa2c42&scoped=true&"
import script from "./TaskBar.vue?vue&type=script&lang=js&"
export * from "./TaskBar.vue?vue&type=script&lang=js&"
import style0 from "./TaskBar.vue?vue&type=style&index=0&id=9ffa2c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffa2c42",
  null
  
)

export default component.exports